// extracted by mini-css-extract-plugin
export default {"root":"speakUp-module--root--uTg7D"};